import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataService } from 'src/app/core/data.service';

@Injectable()
export class HeaderService {
  constructor(private dataService: DataService) {}

  // API response to get the engagement details by id...
  
  public getCompanyName(userId: string): Observable<any>
  {
    return this.dataService.getRequest('User/GetEngagements?userId='+userId);
  }

 
}
